import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';
// import { CloseIcon } from 'assets/icons/CloseIcon';
import { setShowIntroVideo } from 'store/actions';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTE_MAP } from 'consts/url';
import configs from 'configs';

const SESSION_KEY = 'intro_video_initial_route';

/**
 * Records the initial landing route on first call (per session).
 * Returns true only if the initial route was the overview route.
 */
const isInitialRouteOverview = () => {
  const overviewPath = `/${ROUTE_MAP.overview.id}`;
  const stored = sessionStorage.getItem(SESSION_KEY);

  if (stored === null) {
    // First call in this session — record the current pathname
    // Strip the baseUrl prefix so we compare only the route portion
    const rawPath = window.location.pathname;
    const base = configs.baseUrl || '';
    const routePath = (base && rawPath.startsWith(base) ? rawPath.slice(base.length) : rawPath).replace(/\/+$/, '') || '/';
    const isOverview =
      routePath === '/' ||
      routePath === overviewPath ||
      routePath.startsWith(`${overviewPath}/`);
    sessionStorage.setItem(SESSION_KEY, isOverview ? 'overview' : 'other');
    return isOverview;
  }

  return stored === 'overview';
};

export const VideoIntro = ({ onVideoEnd }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { worldParams, showIntroVideo } = useSelector((state) => state);
  const { sceneId } = worldParams;
  const [isFadingOut, setIsFadingOut] = useState(false);

  // Cache the check so it doesn't re-evaluate on re-renders
  const shouldShowRef = useRef(isInitialRouteOverview());

  if (sceneId !== '691c1bc39d4e2e854cda3edb') {
    return null;
  }

  // Skip video if the initial landing was NOT on the overview route
  if (!shouldShowRef.current) {
    return null;
  }

  if (!showIntroVideo) {
    return null;
  }

  const handleVideoEnd = () => {
    setIsFadingOut(true);
    setTimeout(() => {
      dispatch(setShowIntroVideo(false));
      onVideoEnd?.();
    }, 300); // Wait for fade animation to complete
  };

  return (
    <div className={`video-intro-component ${isFadingOut ? 'fade-out' : ''}`}>
      <div className="intro-content">
        <button className="intro-btn" onClick={handleVideoEnd}>
          <span>{t('skip')}</span>
        </button>
        <video
          src="/assets/videos/intro-video.mp4"
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
        />
      </div>
    </div>
  );
};
